import { useOrderContext } from "app/providers/OrderProvider";
import Card from "shared/ui/card";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

interface StatusPaymentInfoProps {
  className?: string;
}

const StatusPaymentInfo = ({ className }: StatusPaymentInfoProps) => {
  const {
    getHumanReadableOrderTotalPaid,
    getHumanReadableTotalRemaining,
    getTotalPayableAmount,
    isOrderAssembly,
  } = useOrderContext();

  const betalenText = isOrderAssembly
    ? "Nog te betalen"
    : "Nog te betalen na montage";
  return (
    <div className={className}>
      <Heading headingLevel="h2" className="gg-text-3xl gg-mb-5">
        Stand van zaken
      </Heading>

      <Card className="gg-px-6 gg-py-10 gg-grid gg-gap-y-5 sm:gg-flex gg-justify-between gg-items-center">
        <div className="gg-flex gg-gap-x-5">
          <div className="gg-grid gg-gap-y-2">
            <Text>Totaalbedrag</Text>
            <Text>Aanbetaald</Text>
          </div>

          <div className="gg-grid gg-gap-y-2">
            <Text className="gg-font-bold">{getTotalPayableAmount()}</Text>
            <Text className="gg-font-bold">
              {getHumanReadableOrderTotalPaid()}
            </Text>
          </div>
        </div>

        <div>
          <Text className="gg-text-sm sm:gg-text-lg gg-mb-1">
            {betalenText}
          </Text>
          <Text className="gg-text-3xl gg-font-bold">
            {getHumanReadableTotalRemaining()}
          </Text>
        </div>
      </Card>
    </div>
  );
};
export default StatusPaymentInfo;
